'use strict';

// Maps states to major cities. This should eventually be deprecated in favor of a more comprehensive solution
module.exports = {
  'NY': 'New York',
  'NJ': 'New York',
  'MA': 'Boston',
  'VA': 'Washington DC',
  'DC': 'Washington DC',
  'MD': 'Washington DC'
};